import Chip from '@ui/Chip';
import { cx } from 'cva';
import { isEmpty } from 'lodash-es';
import React from 'react';

function NonProfitCauses(props) {
  const { nonProfit, className } = props;
  const causes = nonProfit?.causes;

  if (isEmpty(causes)) {
    return null;
  }

  return (
    <div className={cx('flex flex-wrap gap-4', className)}>
      {causes.map((cause) => (
        <Chip key={cause.id} color="secondary" text="small">
          {cause.cause_title}
        </Chip>
      ))}
    </div>
  );
}

export default NonProfitCauses;
